import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  en: {
    // top strip
    "topbar.tagline": "Safe Travels, Happy Memories",
    // nav
    "nav.home": "Home",
    "nav.daily_routes": "Daily Routes",
    "nav.upcoming_tours": "Upcoming Tours",
    "nav.fleet": "Fleet",
    "nav.book_now": "Book Now",
    "nav.custom_trip": "Custom Trip",
    "nav.my_booking": "My Booking",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.login": "Login",
    // hero
    "hero.badge": "Safe Travels, Happy Memories",
    "hero.title_1": "Daily",
    "hero.title_route": "Palus ↔ Pune",
    "hero.title_2": "runs, private hires and pilgrim yatras.",
    "hero.title_3": "5 to 30-seater fleet, AC & Non-AC.",
    "hero.book_ride": "Book a Ride",
    "hero.whatsapp": "WhatsApp",
    "hero.call": "Call",
    "hero.today": "Today",
    "hero.tomorrow": "Tomorrow",
    "hero.daily_service": "Daily Service",
    "hero.time_shortly": "Time Will Be Updated Shortly",
    "hero.from": "From",
    "hero.to": "To",
    "hero.date": "Date",
    "hero.pax": "Pax",
    "hero.ac": "AC",
    "hero.ac_any": "Any",
    "hero.search": "Search Vehicles",
    // road ribbons
    "ribbon.header": "Trusted Since Day One · Pan-Maharashtra Fleet",
    "ribbon.footer": "Safe Travels · Happy Memories",
    // footer
    "footer.explore": "Explore",
    "footer.support": "Support",
    "footer.contact_booking": "Contact for Booking",
    "footer.about_line": "Trusted travel partner for daily routes, private hires, corporate transfers and pilgrim tours across Maharashtra & India.",
    "footer.badge_safe": "Safe Travels",
    "footer.badge_drivers": "Experienced Drivers",
    "footer.link.routes": "Daily Routes",
    "footer.link.tours": "Upcoming Tours",
    "footer.link.fleet": "Fleet",
    "footer.link.book": "Book Vehicle",
    "footer.link.faq": "FAQ",
    "footer.link.track": "Track Booking",
    "footer.link.contact": "Contact",
    "footer.link.admin": "Admin",
    // Vehicles page
    "veh.eyebrow": "Our Fleet",
    "veh.title": "5 to 30-seater. AC & Non-AC.",
    "veh.subtitle": "Handpicked, well-maintained vehicles with experienced drivers. Choose your ride and travel comfortable.",
    "veh.seats": "Seats",
    "veh.comfort": "Comfort",
    "veh.fuel": "Fuel",
    "veh.reg": "Reg",
    // Tours page
    "tours.eyebrow": "Upcoming Tours & Offers",
    "tours.title": "Darshan Yatras, weekend escapes & family tours",
    "tours.subtitle": "Fully organised group tours by Shruti Tours & Travels. Poster-published tours with fixed dates. Grab your seat.",
    "tours.stay_incl": "Stay incl.",
    "tours.no_stay": "No stay",
    "tours.departs": "Departs",
    "tours.ends": "Ends",
    "tours.per_person": "Per person",
    "tours.view_enquire": "View & Enquire",
    // About
    "about.eyebrow": "About Us",
    "about.title": "Shruti Tours & Travels",
    "about.body": "A trusted travel operator based in Pune, running a modern fleet of 5 to 30-seater vehicles across Maharashtra & India. From daily Pune-Mumbai runs to Ashtavinayak darshan yatras, we handle every leg — vehicles, drivers, accommodation, itineraries and paperwork.",
    "about.years": "Years serving Maharashtra",
    "about.fleet_size": "Vehicles in fleet",
    "about.happy": "Happy customers",
    // Why Choose Us
    "why.eyebrow": "Why Choose Us",
    "why.title_prefix": "More than a ride —",
    "why.subtitle": "10,000+ families across Maharashtra choose Shruti Tours for a reason. Punctual, courteous, comfortable — every single time.",
    "why.cta": "Ride with Shruti Tours →",
    // Testimonials
    "test.eyebrow": "What travellers say",
    "test.title": "Loved by families across Maharashtra",
    // Booking
    "book.eyebrow": "Book Your Ride",
    "book.title": "Find your vehicle",
    "book.subtitle": "Choose route or hire a private vehicle. Verified drivers, on-time departures.",
    "book.tab_daily": "Daily Route",
    "book.tab_hire": "Vehicle Hire",
    "book.find_seats": "Find Seats",
    "book.no_results": "No routes found for this date. Try a different date or hire a private vehicle.",
    "book.reserve": "Reserve",
    "book.total": "Total",
    "book.name": "Full Name",
    "book.mobile": "Mobile",
    "book.email": "Email",
    "book.whatsapp": "WhatsApp",
    "book.select_seats": "Select seats",
    "book.select_veh": "Select vehicle type",
    "book.confirm_book": "Confirm Booking",
    "book.pay_now": "Pay Now",
    "book.pay_later": "Pay Later",
    "book.notes": "Special requests",
    // Booking form (detail page)
    "bf.eyebrow": "Booking details",
    "bf.title": "Enter passenger details",
    "bf.step1": "Step 1: Your Vehicle",
    "bf.step2": "Step 2: Pick your seats",
    "bf.step2_hint": "Select up to {n} seat(s) on {name}.",
    "bf.seat_avail": "Available",
    "bf.seat_selected": "Selected",
    "bf.seat_booked": "Booked",
    "bf.front_driver": "Front · Driver",
    "bf.full_name": "Full Name",
    "bf.mobile": "Mobile",
    "bf.whatsapp": "WhatsApp",
    "bf.same_as_mobile": "Same as mobile",
    "bf.email": "Email",
    "bf.from": "From",
    "bf.to": "To",
    "bf.travel_date": "Travel Date",
    "bf.departure_time": "Departure Time",
    "bf.passengers": "Passengers",
    "bf.vehicle_pref": "Vehicle Preference (choose first)",
    "bf.ac_pref": "AC / Non-AC",
    "bf.ac": "AC",
    "bf.nonac": "Non-AC",
    "bf.pickup": "Pickup Location",
    "bf.pickup_ph": "Address / landmark",
    "bf.drop": "Drop Location",
    "bf.notes": "Notes",
    "bf.fare_summary": "Fare Summary",
    "bf.f_type": "Type",
    "bf.f_route": "Route",
    "bf.f_seats": "Seats",
    "bf.f_vehicle": "Vehicle",
    "bf.f_pax": "Passengers",
    "bf.total": "Total",
    "bf.booking_dots": "Booking…",
    "bf.confirm": "Confirm Booking",
    "bf.wa_after": "You'll get a Booking ID via WhatsApp. Pay online after or at pickup.",
    "bf.early_arrival": "Please arrive 10–15 min early at the pickup point. Vehicles depart on time.",
    "bf.assigned_by_ops": "Assigned by operations",
    "bf.seater": "seater",
    // Booking confirmation
    "conf.thanks": "Thank you! Booking received.",
    "conf.pending": "Awaiting confirmation",
    "conf.confirmed": "Confirmed",
    "conf.your_booking": "Your booking",
    "conf.driver_soon": "Our team will assign a driver and share contact soon.",
    "conf.loading": "Loading…",
    "conf.booking_confirmed": "Booking Confirmed",
    "conf.thank_you": "Thank you, {name}!",
    "conf.booking_id": "Booking ID",
    "conf.total": "Total",
    "conf.route": "Route",
    "conf.travel_date": "Travel Date",
    "conf.passengers": "Passengers",
    "conf.vehicle": "Vehicle",
    "conf.pickup": "Pickup",
    "conf.to_be_assigned": "To be assigned",
    "conf.status": "Status",
    "conf.pay_online": "Pay Online",
    "conf.redirecting": "Redirecting…",
    "conf.call_support": "Call Support",
    "conf.track_booking": "Track Booking",
    "conf.arrive_early": "Please arrive 10–15 minutes early",
    "conf.arrive_early_body": "Our vehicles depart on time. Kindly reach the pickup point at least 10–15 minutes before departure so we can start punctually.",
    "conf.wa_queued": "A WhatsApp confirmation has been queued. (Mocked in demo — view in admin → Notifications.)",
    // Contact
    "contact.eyebrow": "Get in Touch",
    "contact.title": "We're here to help",
    "contact.subtitle": "Reach us by phone, WhatsApp or email — we typically respond within an hour during business hours.",
    "contact.your_name": "Your Name",
    "contact.your_mobile": "Your Mobile",
    "contact.message": "Message",
    "contact.send": "Send Message",
    // FAQ
    "faq.eyebrow": "Frequently Asked Questions",
    "faq.title": "Everything you need to know",
    // Tour detail
    "tour.inclusions": "Inclusions",
    "tour.exclusions": "Exclusions",
    "tour.itinerary": "Itinerary",
    "tour.highlights": "Highlights",
    "tour.book_this": "Book this tour",
    "tour.enquire": "Enquire on WhatsApp",
    "tour.seats_left": "seats available",
  },
  mr: {
    // top strip
    "topbar.tagline": "सुरक्षित प्रवास, आनंदी आठवणी",
    // nav
    "nav.home": "मुख्यपृष्ठ",
    "nav.daily_routes": "दैनिक मार्ग",
    "nav.upcoming_tours": "आगामी सहली",
    "nav.fleet": "ताफा",
    "nav.book_now": "बुक करा",
    "nav.custom_trip": "सानुकूल सहल",
    "nav.my_booking": "माझी बुकिंग",
    "nav.about": "आमच्याबद्दल",
    "nav.contact": "संपर्क",
    "nav.login": "लॉगिन",
    // hero
    "hero.badge": "सुरक्षित प्रवास, आनंदी आठवणी",
    "hero.title_1": "दैनिक",
    "hero.title_route": "पलूस ↔ पुणे",
    "hero.title_2": "प्रवास, खासगी वाहने आणि यात्रा.",
    "hero.title_3": "५ ते ३० आसनी ताफा, एसी व नॉन-एसी.",
    "hero.book_ride": "प्रवास बुक करा",
    "hero.whatsapp": "व्हॉट्सअ‍ॅप",
    "hero.call": "कॉल",
    "hero.today": "आज",
    "hero.tomorrow": "उद्या",
    "hero.daily_service": "दैनिक सेवा",
    "hero.time_shortly": "वेळ लवकरच अपडेट होईल",
    "hero.from": "पासून",
    "hero.to": "पर्यंत",
    "hero.date": "तारीख",
    "hero.pax": "प्रवासी",
    "hero.ac": "एसी",
    "hero.ac_any": "कोणतेही",
    "hero.search": "वाहने शोधा",
    // road ribbons
    "ribbon.header": "पहिल्या दिवसापासून विश्वासू · संपूर्ण महाराष्ट्रात सेवा",
    "ribbon.footer": "सुरक्षित प्रवास · आनंदी आठवणी",
    // footer
    "footer.explore": "अन्वेषण",
    "footer.support": "आधार",
    "footer.contact_booking": "बुकिंगसाठी संपर्क",
    "footer.about_line": "महाराष्ट्र आणि भारतभर दैनिक मार्ग, खासगी वाहने, कॉर्पोरेट ट्रान्सफर आणि यात्रा सहलींसाठी विश्वासू प्रवास भागीदार.",
    "footer.badge_safe": "सुरक्षित प्रवास",
    "footer.badge_drivers": "अनुभवी चालक",
    "footer.link.routes": "दैनिक मार्ग",
    "footer.link.tours": "आगामी सहली",
    "footer.link.fleet": "ताफा",
    "footer.link.book": "वाहन बुक करा",
    "footer.link.faq": "प्रश्नोत्तरे",
    "footer.link.track": "बुकिंग ट्रॅक करा",
    "footer.link.contact": "संपर्क",
    "footer.link.admin": "प्रशासक",
    // Vehicles page
    "veh.eyebrow": "आमचा ताफा",
    "veh.title": "५ ते ३० आसनी. एसी व नॉन-एसी.",
    "veh.subtitle": "अनुभवी चालकांसह उत्कृष्ट देखभाल केलेली निवडक वाहने. आपले वाहन निवडा आणि आरामात प्रवास करा.",
    "veh.seats": "आसने",
    "veh.comfort": "आराम",
    "veh.fuel": "इंधन",
    "veh.reg": "नोंदणी",
    // Tours page
    "tours.eyebrow": "आगामी सहली आणि ऑफर्स",
    "tours.title": "दर्शन यात्रा, वीकेंड सहली आणि कौटुंबिक टूर्स",
    "tours.subtitle": "श्रुती टूर्स अँड ट्रॅव्हल्सद्वारे संपूर्णपणे आयोजित सहली. ठराविक तारखांसह जाहीर केलेल्या सहली. आपली जागा राखून ठेवा.",
    "tours.stay_incl": "मुक्कामासह",
    "tours.no_stay": "मुक्कामाशिवाय",
    "tours.departs": "प्रस्थान",
    "tours.ends": "समाप्ती",
    "tours.per_person": "प्रति व्यक्ती",
    "tours.view_enquire": "पाहा व चौकशी",
    // About
    "about.eyebrow": "आमच्याबद्दल",
    "about.title": "श्रुती टूर्स अँड ट्रॅव्हल्स",
    "about.body": "पुण्यात स्थित विश्वासू प्रवास ऑपरेटर, महाराष्ट्र आणि भारतभर ५ ते ३० आसनी आधुनिक ताफा चालवतो. दैनिक पुणे-मुंबई सेवेपासून अष्टविनायक दर्शन यात्रेपर्यंत — वाहने, चालक, निवास, कार्यक्रम आणि कागदपत्रे सर्व आम्ही सांभाळतो.",
    "about.years": "वर्षे महाराष्ट्रात सेवा",
    "about.fleet_size": "ताफ्यात वाहने",
    "about.happy": "समाधानी ग्राहक",
    // Why Choose Us
    "why.eyebrow": "आम्हाला का निवडावे",
    "why.title_prefix": "फक्त प्रवास नाही —",
    "why.subtitle": "महाराष्ट्रातील १०,०००+ कुटुंबे श्रुती टूर्स निवडण्यामागे एक कारण आहे. वेळेवर, विनम्र, आरामदायक — प्रत्येक वेळी.",
    "why.cta": "श्रुती टूर्ससोबत प्रवास करा →",
    // Testimonials
    "test.eyebrow": "प्रवासी काय म्हणतात",
    "test.title": "महाराष्ट्रातील कुटुंबांनी आवडलेले",
    // Booking
    "book.eyebrow": "प्रवास बुक करा",
    "book.title": "आपले वाहन शोधा",
    "book.subtitle": "मार्ग निवडा किंवा खासगी वाहन भाड्याने घ्या. अनुभवी चालक, वेळेवर प्रस्थान.",
    "book.tab_daily": "दैनिक मार्ग",
    "book.tab_hire": "वाहन भाडे",
    "book.find_seats": "जागा शोधा",
    "book.no_results": "या तारखेसाठी मार्ग सापडले नाहीत. वेगळी तारीख निवडा किंवा खासगी वाहन भाड्याने घ्या.",
    "book.reserve": "आरक्षित करा",
    "book.total": "एकूण",
    "book.name": "पूर्ण नाव",
    "book.mobile": "मोबाईल",
    "book.email": "ईमेल",
    "book.whatsapp": "व्हॉट्सअ‍ॅप",
    "book.select_seats": "जागा निवडा",
    "book.select_veh": "वाहन प्रकार निवडा",
    "book.confirm_book": "बुकिंग निश्चित करा",
    "book.pay_now": "आत्ता पैसे भरा",
    "book.pay_later": "नंतर पैसे भरा",
    "book.notes": "विशेष विनंत्या",
    // Booking form (detail page)
    "bf.eyebrow": "बुकिंग तपशील",
    "bf.title": "प्रवाशांचे तपशील भरा",
    "bf.step1": "पायरी १: आपले वाहन",
    "bf.step2": "पायरी २: आपल्या जागा निवडा",
    "bf.step2_hint": "{name} वर {n} पर्यंत जागा निवडा.",
    "bf.seat_avail": "उपलब्ध",
    "bf.seat_selected": "निवडलेली",
    "bf.seat_booked": "बुक झालेली",
    "bf.front_driver": "समोर · चालक",
    "bf.full_name": "पूर्ण नाव",
    "bf.mobile": "मोबाईल",
    "bf.whatsapp": "व्हॉट्सअ‍ॅप",
    "bf.same_as_mobile": "मोबाईलप्रमाणेच",
    "bf.email": "ईमेल",
    "bf.from": "पासून",
    "bf.to": "पर्यंत",
    "bf.travel_date": "प्रवासाची तारीख",
    "bf.departure_time": "प्रस्थान वेळ",
    "bf.passengers": "प्रवासी",
    "bf.vehicle_pref": "वाहन प्राधान्य (आधी निवडा)",
    "bf.ac_pref": "एसी / नॉन-एसी",
    "bf.ac": "एसी",
    "bf.nonac": "नॉन-एसी",
    "bf.pickup": "पिकअप स्थान",
    "bf.pickup_ph": "पत्ता / खूण",
    "bf.drop": "ड्रॉप स्थान",
    "bf.notes": "टिप्पण्या",
    "bf.fare_summary": "भाडे सारांश",
    "bf.f_type": "प्रकार",
    "bf.f_route": "मार्ग",
    "bf.f_seats": "जागा",
    "bf.f_vehicle": "वाहन",
    "bf.f_pax": "प्रवासी",
    "bf.total": "एकूण",
    "bf.booking_dots": "बुकिंग होत आहे…",
    "bf.confirm": "बुकिंग निश्चित करा",
    "bf.wa_after": "व्हॉट्सअ‍ॅपवर आपला बुकिंग आयडी मिळेल. नंतर ऑनलाइन किंवा पिकअपच्या वेळी पैसे भरा.",
    "bf.early_arrival": "कृपया पिकअप स्थळी १०–१५ मिनिटे लवकर पोहोचा. वाहने वेळेवर सुटतात.",
    "bf.assigned_by_ops": "ऑपरेशन्सद्वारे नेमले जाईल",
    "bf.seater": "आसनी",
    // Booking confirmation
    "conf.thanks": "धन्यवाद! बुकिंग प्राप्त झाले.",
    "conf.pending": "पुष्टीकरणाची प्रतीक्षा",
    "conf.confirmed": "पुष्टी झाले",
    "conf.your_booking": "आपले बुकिंग",
    "conf.driver_soon": "आमची टीम लवकरच चालक नेमेल आणि संपर्क सामायिक करेल.",
    "conf.loading": "लोड होत आहे…",
    "conf.booking_confirmed": "बुकिंग निश्चित झाले",
    "conf.thank_you": "धन्यवाद, {name}!",
    "conf.booking_id": "बुकिंग आयडी",
    "conf.total": "एकूण",
    "conf.route": "मार्ग",
    "conf.travel_date": "प्रवासाची तारीख",
    "conf.passengers": "प्रवासी",
    "conf.vehicle": "वाहन",
    "conf.pickup": "पिकअप",
    "conf.to_be_assigned": "नेमणूक बाकी",
    "conf.status": "स्थिती",
    "conf.pay_online": "ऑनलाइन पैसे भरा",
    "conf.redirecting": "पुनर्निर्देशित होत आहे…",
    "conf.call_support": "मदतीसाठी कॉल करा",
    "conf.track_booking": "बुकिंग ट्रॅक करा",
    "conf.arrive_early": "कृपया १०–१५ मिनिटे लवकर पोहोचा",
    "conf.arrive_early_body": "आमची वाहने वेळेवर सुटतात. कृपया प्रस्थानाच्या किमान १०–१५ मिनिटे आधी पिकअप स्थळी पोहोचा जेणेकरून आम्ही वेळेवर निघू शकू.",
    "conf.wa_queued": "व्हॉट्सअ‍ॅप पुष्टीकरण रांगेत आहे. (डेमोमध्ये मॉक — प्रशासक → सूचना मध्ये पहा.)",
    // Contact
    "contact.eyebrow": "संपर्क साधा",
    "contact.title": "आम्ही मदतीसाठी येथे आहोत",
    "contact.subtitle": "फोन, व्हॉट्सअ‍ॅप किंवा ईमेलद्वारे संपर्क साधा — कामकाजाच्या वेळेत आम्ही सामान्यतः एका तासात प्रतिसाद देतो.",
    "contact.your_name": "आपले नाव",
    "contact.your_mobile": "आपला मोबाईल",
    "contact.message": "संदेश",
    "contact.send": "संदेश पाठवा",
    // FAQ
    "faq.eyebrow": "वारंवार विचारले जाणारे प्रश्न",
    "faq.title": "आपल्याला जाणून घ्यायला हवे ते सर्व",
    // Tour detail
    "tour.inclusions": "समाविष्ट",
    "tour.exclusions": "समाविष्ट नाही",
    "tour.itinerary": "कार्यक्रम",
    "tour.highlights": "ठळक वैशिष्ट्ये",
    "tour.book_this": "ही सहल बुक करा",
    "tour.enquire": "व्हॉट्सअ‍ॅपवर चौकशी",
    "tour.seats_left": "जागा उपलब्ध",
  },
};

const LanguageCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem("lang");
    if (stored === "en" || stored === "mr") return stored;
    // Auto-detect: Marathi speakers or Marathi-region browsers see Marathi first
    const nav = (navigator.language || "en").toLowerCase();
    if (nav.startsWith("mr")) return "mr";
    return "en";
  });

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("lang", l);
    document.documentElement.setAttribute("lang", l);
  };

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    // Sync across tabs
    const handler = (e) => { if (e.key === "lang" && e.newValue) setLangState(e.newValue); };
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, [lang]);

  const t = (key, fallback) => (DICT[lang] && DICT[lang][key]) || DICT.en[key] || fallback || key;

  return <LanguageCtx.Provider value={{ lang, setLang, t }}>{children}</LanguageCtx.Provider>;
}

export const useLang = () => useContext(LanguageCtx);
export const useT = () => useContext(LanguageCtx).t;
